import { Card } from './card';
import { CardId } from './card-id';
import { PileType } from '../logic-types';

export class CardScoreRecord {
  private cardId: CardId;

  public get placedOnTableau(): boolean {
    return this.hasTableauPoints;
  }

  public get placedOnFoundation(): boolean {
    return this.hasFoundationPoints;
  }

  private cardIndex: number;
  private hasTableauPoints = false;
  private hasFoundationPoints = false;

  constructor(cardId: CardId, cardIndex: number) {
    this.cardId = cardId;
    this.cardIndex = cardIndex;
  }

  public matchesCardId(card: Card): boolean {
    return this.cardId === card.cardId;
  }

  public saveMoveAndReturnNewPoints(pileType: PileType) {
    if (pileType === PileType.Tableau && !this.hasTableauPoints) {
      this.hasTableauPoints = true;
      return 10;
    }

    if (pileType === PileType.Foundation && !this.hasFoundationPoints) {
      this.hasFoundationPoints = true;
      return 20;
    }

    return 0;
  }
}
